import { jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ jsx("svg", { width: 32, height: 26, viewBox: "0 0 32 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M12.8 0.5H0V25.5H32V3.625H16L12.8 0.5Z", fill: "currentColor" }) });
export default SvgFolder;
